import { BusinessModel } from "@/models/BusinessModel";
import { OrderModel } from "@/models/OrderModel";
import { CouponModel } from "@/models/CouponModel";
import { ref } from "vue";

export const business = ref<BusinessModel>()
export const restaurant = ref<any>({})
export const addOns = ref<any>({})
export const categories = ref<any>()
export const cart = ref<any>(JSON.parse(localStorage.getItem('cart') as string) ? JSON.parse(localStorage.getItem('cart') as string) : [])
export const appliedCoupon = ref<CouponModel | null>(null)
export const deliveryType = ref<string | null>(localStorage.getItem('deliveryType') ?? 'presencial')
export const paymentMethod = ref<string>(localStorage.getItem('paymentMethod') ?? 'pix')
export const changeAmount = ref<number | null>(null)
export const orderTiming = ref<string>('immediate')
export const scheduledAt = ref<string | null>(null)
export const orders = ref<OrderModel[]>([])
export const cmFirebaseToken = ref<string | null>(localStorage.getItem("cmFirebaseToken") ?? null)
export const tableNumber = ref<number | null>(JSON.parse(localStorage.getItem("table_number") as string) ?? null)
export const isLoading = ref<boolean>(false)
export const hideNav = ref<boolean>(false)
export const apiBaseUrl = process.env.VUE_APP_API_BASE_URL

export function getProductImage(product: any, thumb = false) {
    if (product?.media && product.media.length > 0) {
        if (thumb) {
            const thumbMedia = product.media.find((m: any) => m.type === 'main' && m.isThumb)
            if (thumbMedia?.source) return thumbMedia.source
        }

        const mainMedia = product.media.find((m: any) => m.type === 'main' && !m.isThumb) || product.media[0];
        if (mainMedia?.source) return mainMedia.source;
    }


    if (product?.smallImage?.path) {
        return `${apiBaseUrl}/storage/${product.smallImage.path}`;
    }

    if (product?.largeImage?.path) {
        return `${apiBaseUrl}/storage/${product.largeImage.path}`;
    }

    return '/assets/no-image.png';
}